import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import StockNavbar from "./StockNavbar";
import { Link, NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import Pagination from "../General/Pagination";
import csvDownload from "json-to-csv-export";
import { useStockRegisterTypes } from "./useStockRegisterTypes";

const StockMovementReport = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [listOfRecords, setListOfRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);

  const [startDate, setStartDate] = useState(
    moment().subtract(2, "months").format(config.date_format_input)
  );
  const [endDate, setEndDate] = useState(moment().format(config.date_format_input));
  const [registerType, setRegisterType] = useState("");
  const [movementType, setMovementType] = useState("");
  const [itemId, setItemId] = useState("");
  const { registerTypes } = useStockRegisterTypes(true);

  useEffect(() => {
    document.title = "Stock Movement Report";
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      StartDate: startDate,
      EndDate: endDate,
      Register_Type: registerType,
      MovementType: movementType,
      ID: parseInt(itemId, 10) || 0,
    };

    axios({
      method: "post",
      url: config.base_url + "Stock/GetStockMovementReport",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setListOfRecords(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setListOfRecords([]);
          setTotalRecords(0);
          if (response.data.status_message) {
            toast.error(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  }, [UserID, AccessKey, MemberType, pageNo, pageSize, startDate, endDate, registerType, movementType, itemId]);

  const buildPrintUrl = () => {
    const params = new URLSearchParams();
    params.set("startDate", startDate);
    params.set("endDate", endDate);
    if (registerType) {
      params.set("registerType", registerType);
    }
    if (movementType) {
      params.set("movementType", movementType);
    }
    if (itemId) {
      params.set("itemId", itemId);
    }
    return `/StockManagement/StockMovementReportPrint?${params.toString()}`;
  };

  const exportCsv = () => {
    if (!listOfRecords || listOfRecords.length === 0) {
      toast.error("No data to export.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    csvDownload({
      data: listOfRecords.map((item) => ({
        Date: item.Dated ? moment(item.Dated).format(config.date_format) : "",
        Stock_Code: item.Stock_Code,
        Item_Name: item.Item_Name,
        Register_Type: item.Register_Type,
        Type: item.MovementType,
        IN: item.Item_In || 0,
        OUT: item.Item_Out || 0,
        Balance: item.Item_Balance,
        Price: item.Stock_Price,
        Custodian: item.Custodian || "",
        Description: item.Description || "",
        Use_Detail: item.Use_Detail || "",
      })),
      filename: "stock-movement-report",
    });
  };

  const renderRows = () => {
    if (listOfRecords != null && listOfRecords.length > 0) {
      let count = 1;
      return listOfRecords.map((item, index) => (
        <tr key={index}>
          <td>{count++ + pageSize * (pageNo - 1)}</td>
          <td>{item.Dated ? moment(item.Dated).format("DD/MM/YYYY") : ""}</td>
          <td>{item.Stock_Code}</td>
          <td>{item.Item_Name}</td>
          <td>{item.Register_Type}</td>
          <td>{item.MovementType}</td>
          <td>{item.Item_In > 0 ? item.Item_In : "-"}</td>
          <td>{item.Item_Out > 0 ? item.Item_Out : "-"}</td>
          <td>{item.Item_Balance}</td>
          <td>{item.Custodian}</td>
          <td>{item.Description}</td>
          <td>
            <NavLink
              to={`/StockManagement/StockDetail/${item.Item_ID}`}
              className="blue"
              title="Item ledger"
            >
              <i className="ri-pages-line"></i>
            </NavLink>
          </td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="12">
          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
            No movements found for the selected filters.
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <StockNavbar />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/Dashboard">Dashboard</NavLink>
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/StockManagement/StocksDashboard">Stocks</NavLink>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Movement Report
                  </li>
                </ol>
              </nav>
              <div className="page-title">Stock Movement Report</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <NavLink
                  to="/StockManagement/ManageStockCategory"
                  className="button button-white button-icon"
                >
                  Manage Stock
                  <i className="ri-list-check"></i>
                </NavLink>
                <button
                  type="button"
                  onClick={() => setShowFilters((v) => !v)}
                  className="button button-white button-icon"
                >
                  {showFilters ? "Hide Filters" : "Show Filters"}
                  <i className="ri-filter-3-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className={`collapse ${showFilters ? "show" : ""}`}>
            <div className="card mb-2">
              <div className="card-body p-md-4">
                <div className="row align-items-end gy-2">
                  <div className="col-md-2">
                    <label>Start date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={startDate}
                      onChange={(e) => {
                        setPageNo(1);
                        setStartDate(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>End date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={endDate}
                      onChange={(e) => {
                        setPageNo(1);
                        setEndDate(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>Movement</label>
                    <select
                      className="form-select"
                      value={movementType}
                      onChange={(e) => {
                        setPageNo(1);
                        setMovementType(e.target.value);
                      }}
                    >
                      <option value="">All</option>
                      <option value="IN">IN (Receive)</option>
                      <option value="OUT">OUT (Issue)</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>Register type</label>
                    <select
                      className="form-select"
                      value={registerType}
                      onChange={(e) => {
                        setPageNo(1);
                        setRegisterType(e.target.value);
                      }}
                    >
                      <option value="">All</option>
                      {registerTypes.map((rt) => (
                        <option key={rt.ID} value={rt.RegisterName}>
                          {rt.RegisterName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label>Item ID (optional)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={itemId}
                      onChange={(e) => {
                        setPageNo(1);
                        setItemId(e.target.value);
                      }}
                      min="0"
                    />
                  </div>
                  <div className="col-md-1 text-end">
                    <span className="counting">{totalRecords}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body table_card">
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th>Date</th>
                    <th>Code</th>
                    <th>Item</th>
                    <th>Register</th>
                    <th>Type</th>
                    <th>IN</th>
                    <th>OUT</th>
                    <th>Balance</th>
                    <th>Custodian</th>
                    <th>Description</th>
                    <th>Ledger</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="12" className="text-center">
                        <Spinner animation="border" role="status" />
                      </td>
                    </tr>
                  ) : (
                    renderRows()
                  )}
                </tbody>
              </table>

              {totalRecords > pageSize && (
                <div className="pagination-wrap">
                  <Pagination
                    pageNo={pageNo}
                    pageSize={pageSize}
                    totalRecords={totalRecords}
                    onPageChange={setPageNo}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="card mt-md-3">
            <div className="card-body text-end">
              <Link
                to={buildPrintUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="button button-white me-2"
              >
                Print Report
                <i className="ri-printer-line ms-1"></i>
              </Link>
              <button type="button" className="button button-primary" onClick={exportCsv}>
                Export CSV
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StockMovementReport;
